<template>
  <div>
    <!-- 专享政策 -->
    <div class="wrap-container">
      <ul class="tabbar" @click="changeTab">
        <li
          v-for="(item, index) in tabInfo.list"
          :key="index"
          class="tab-item"
          :class="{ 'tab--active': tabInfo.active === item.value }"
          :data-cpn="item.value"
        >
          {{ item.label }}
        </li>
      </ul>
      <!-- <keep-alive> -->
      <component :is="tabInfo.active"></component>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VipPush from "./VipPush";
import SwPolicySubscription from "../sw-policy-subscription/SwPolicySubscription";
export default {
  name: "SwPolicyVip",
  components: {
    VipPush,
    SwPolicySubscription,
  },
  props: {},
  data() {
    return {
      tabInfo: {
        active: "vipPush",
        list: [
          { value: "vipPush", label: "精准推送" },
          { value: "SwPolicySubscription", label: "自主订阅" },
        ],
      },
      listData: [],
      policyInfos: [
        {
          width: "200px",
          label: "政策等级",
        },
        {
          width: "400px",
          label: "发文单位",
          valueKey: "fbjg",
        },
        {
          label: "发布日期",
          valueKey: "publictime",
        },
      ],
      pageInfo: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    /**
     * @description: 税类型下的标签列表
     * @return {Array}
     */
    cpu_tagList() {
      // 标签的parentId为父类的id
      let arr = this.searchInfo.typeTagData.filter((cv) => cv.parentId !== "0");
      if (!this.searchInfo.data.type) return arr;
      return arr.filter((cv) => cv.parentId == this.searchInfo.data.type);
    },
    cpu_policyProjectList() {
      return function (policy) {
        return policy.cfgPermitItemInfoList || [];
      };
    },
  },
  methods: {
    changeTab(e) {
      if (e.target.nodeName.toLowerCase() === "li") {
        this.tabInfo.active = e.target.getAttribute("data-cpn");
      }
      // if (this.tabInfo.active == "vipPush") {
      //
      //   this.$message({
      //     offset:300,
      //     message: "功能正在建设中...",
      //     type: "warning",
      //   });
      // }
    },
    changePage() {},
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.wrap-container {
  width: $width;
  margin: 0 auto;
}
.tabbar {
  position: relative;
  margin-top: 10px;
  font-size: 18px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #1472FF;
  }
}
.tab-item {
  display: inline-block;
  padding: 0.5rem 1rem;
  color: #1472FF;
  cursor: pointer;

  &.tab--active {
    color: #fff;
    background-color: #1472FF;
    // border-bottom: 4px solid #d71517;
  }
}
.wrap-content {
  background-color: #ffffff;
  .content-body {
    min-height: 5rem;
    overflow: auto;
  }
}
.policy-item {
  border: 1px solid rgba($col-theme, 0.5);
  -webkit-transition: all 0.4s ease 0s;
  -moz-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;

  .policy-zcfs {
    .zcfs-item {
      display: inline-block;
      border: 1px solid $col-theme;
      color: $col-theme;
      margin-left: -10px;
    }
  }
  .policy-name {
    color: #000000;
    cursor: pointer;

    &:hover {
      color: $col-theme;
    }
  }
  .policy-content {
    color: #000000;
  }
  .policy-infos {
    display: -webkit-flex;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 5px;

    .info-item {
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;

      .info-value {
        flex: 1;
        min-width: 0;
      }
    }
  }
  .policy_footer {
    padding-top: 5px;
    padding-bottom: 5px;
    border-top: 1px solid rgba($col-theme, 0.5);
    margin-top: 5px;
    overflow: auto;
  }
  .policy-tag {
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
  }
  &:hover {
    box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}
</style>
